const koreanDate = new Intl.DateTimeFormat("ko-KR", {year: "numeric", month: "long", day: "numeric", timeZone: "Asia/Seoul"});

/** Display only; retain the provider value and distinguish occurrence from publication. */
export function occurrenceDateLabel(value: string | null | undefined): string {
  if (!value || !Number.isFinite(Date.parse(value))) return "발생일 미상";
  return koreanDate.format(new Date(value));
}
